import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  useTheme, 
  Box, 
  Typography, 
  Divider, 
} from "@mui/material";
import {
  ManageAccountsOutlined,
  LocationOnOutlined,
  WorkOutlineOutlined,
  VisibilityOutlined,
  FavoriteBorderOutlined,
} from "@mui/icons-material";
import api from 'state/axios';
import UserImage from "components/UserImage";
import FlexBetween from "components/FlexBetween";
import WidgetWrapper from "components/WidgetWrapper";


const UserWidget = ({ userId, picturePath }) => {
  const [user, setUser] = useState(null);
  const { palette } = useTheme();
  const navigate = useNavigate();
  const dark = palette.neutral.darkest;
  const medium = palette.neutral.deep;
  const main = palette.neutral.main;

  

  useEffect(() => {
    const getUser = async () => {
      const response = await api.get(`/users/${userId}`);

      setUser(response.data);
    };
    
    getUser();
  }, [userId]);

  if (!user) return null;

  const { 
    firstName, 
    lastName, 
    location, 
    occupation, 
    viewedProfile, 
    impressions, 
    friends 
  } = user;

  
  return (
    <WidgetWrapper>
      {/* ROW 1 — Avatar + name + manage */}
      <FlexBetween gap={1} pb={1}>
        <FlexBetween gap={1} sx={{ cursor: "pointer" }} onClick={() => navigate(`/profile/${userId}`)}>
          <UserImage image={picturePath} size="55px" />
          <Box>
            <Typography
              variant="h4"
              color={dark}
              fontWeight="500"
              sx={{ "&:hover": { color: palette.primary.light } }}
            >
              {firstName} {lastName}
            </Typography>
            <Typography color={medium} fontSize="0.8rem">
              {friends.length} friends
            </Typography>
          </Box>
        </FlexBetween>
        <ManageAccountsOutlined
          sx={{ cursor: "pointer", color: main, "&:hover": { color: palette.primary.main } }}
          onClick={() => navigate(`/profile/${userId}`)}
        />
      </FlexBetween>

      <Divider />

      {/* ROW 2 — Location + occupation */}
      <Box p="0.75rem 0">
        <Box display="flex" alignItems="center" gap="1rem" mb="0.5rem">
          <LocationOnOutlined fontSize="medium" sx={{ color: main }} />
          <Typography color={medium}>{location || "—"}</Typography>
        </Box>
        <Box display="flex" alignItems="center" gap="1rem">
          <WorkOutlineOutlined fontSize="medium" sx={{ color: main }} />
          <Typography color={medium}>{occupation || "—"}</Typography>
        </Box>
      </Box>

      <Divider />

      {/* ROW 3 — Profile views + impressions */}
      <Box p="0.75rem 0">
        <FlexBetween mb="0.5rem">
          <Box display="flex" alignItems="center" gap="0.5rem">
            <VisibilityOutlined fontSize="small" sx={{ color: main }} />
            <Typography color={medium} fontSize="0.85rem">Profile views</Typography>
          </Box>
          <Typography color={dark} fontWeight="500">{viewedProfile ?? 0}</Typography>
        </FlexBetween>
        <FlexBetween>
          <Box display="flex" alignItems="center" gap="0.5rem">
            <FavoriteBorderOutlined fontSize="small" sx={{ color: main }} />
            <Typography color={medium} fontSize="0.85rem">Post impressions</Typography>
          </Box>
          <Typography color={dark} fontWeight="500">{impressions ?? 0}</Typography>
        </FlexBetween>
      </Box>
    </WidgetWrapper>
  );
};

export default UserWidget;
